export default __webpack_public_path__ + "static/e2-comp-5015c1638ee3836443a1293f127a8737.mp4";